"use client";

import clsx from "clsx";

import { useTranslation } from "~/app/hooks/useTranslation";
import Img1Tr from "~/assets/images/marketing/chatbot1-tr.png";
import Img1 from "~/assets/images/marketing/chatbot1.png";
import Img2Tr from "~/assets/images/marketing/chatbot2-tr.png";
import Img2 from "~/assets/images/marketing/chatbot2.png";
import Img3Tr from "~/assets/images/marketing/chatbot3-tr.png";
import Img3 from "~/assets/images/marketing/chatbot3.png";
import Img4Tr from "~/assets/images/marketing/chatbot4-tr.png";
import Img4 from "~/assets/images/marketing/chatbot4.png";
import CollapsibleHeroCollection from "~/common/components/CollapsibleHeroCollection";
import SectionWrapper from "~/common/components/SectionWrapper";

import styles from "./SectionChatbot.module.scss";

export default function SectionChatbot({ locale }) {
  const { t } = useTranslation();

  const section2Data = [
    {
      id: "chatbot",
      titleKey: /** @i18n */ "solutions.customerSupport.chatbot1.title",
      descriptionKey: /** @i18n */ "solutions.customerSupport.chatbot1.description",
      image: locale === "tr" ? Img1Tr : Img1,
    },
    {
      id: "templates",
      titleKey: /** @i18n */ "solutions.customerSupport.chatbot2.title",
      descriptionKey: /** @i18n */ "solutions.customerSupport.chatbot2.description",
      image: locale === "tr" ? Img2Tr : Img2,
    },
    {
      id: "live-support",
      titleKey: /** @i18n */ "solutions.customerSupport.chatbot3.title",
      descriptionKey: /** @i18n */ "solutions.customerSupport.chatbot3.description",
      image: locale === "tr" ? Img3Tr : Img3,
    },
    {
      id: "multi-channel",
      titleKey: /** @i18n */ "solutions.customerSupport.chatbot4.title",
      descriptionKey: /** @i18n */ "solutions.customerSupport.chatbot4.description",
      image: locale === "tr" ? Img4Tr : Img4,
      imageProps: {
        style: {},
      },
    },
  ];

  return (
    <SectionWrapper className={styles.section} background={"/ecommerce/sectionChatbot-hero.svg"}>
      <div className={clsx("card", styles.card)}>
        <CollapsibleHeroCollection
          items={section2Data}
          t={t}
          imageContainerStyle={{
            width: 450,
            height: 600,
          }}
        />
      </div>
    </SectionWrapper>
  );
}
